import React from 'react';
import { CheckCircle2, Shield, Lock, Trash2 } from 'lucide-react';

export function GDPRInfo() {
  const gdprPoints = [
    {
      icon: <Lock className="w-5 h-5" />,
      title: "Ingen lagring",
      description: "Vi sparar aldrig dina personuppgifter",
      checks: ["Temporär hantering", "Ingen databas", "Ingen delning"]
    },
    {
      icon: <Shield className="w-5 h-5" />,
      title: "Säker process",
      description: "Din information är skyddad",
      checks: ["Krypterad överföring", "Säker hantering", "Direkt process"]
    },
    {
      icon: <Trash2 className="w-5 h-5" />,
      title: "Automatisk radering",
      description: "Din data raderas direkt efter användning",
      checks: ["Omedelbar radering", "Inga kopior", "Inget arkiv"]
    }
  ];

  return (
    <div className="bg-gradient-to-br from-[#F2C1D1]/10 to-[#A3C1DA]/10 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center p-1.5 bg-[#F2C1D1]/20 rounded-full mb-3">
            <Shield className="w-6 h-6 text-[#A3C1DA]" />
          </div>
          <h3 className="text-xl font-bold text-gray-900">
            Din integritet är viktig
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {gdprPoints.map((point, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5 text-center"
            >
              <div className="flex flex-col items-center mb-3">
                <div className="p-2 bg-[#F2C1D1]/10 rounded-full mb-2">
                  <div className="text-[#A3C1DA]">
                    {point.icon}
                  </div>
                </div>
                <h4 className="font-semibold text-gray-900 text-sm mb-1">{point.title}</h4>
                <p className="text-xs text-gray-600">{point.description}</p>
              </div>

              <div className="space-y-1.5">
                {point.checks.map((check, idx) => (
                  <div key={idx} className="flex items-center justify-center gap-1.5 text-xs">
                    <CheckCircle2 className="w-3.5 h-3.5 text-[#B5D3B1]" />
                    <span className="text-gray-700">{check}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center">
          <p className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white rounded-full text-xs text-gray-600 shadow-sm">
            <Shield className="w-3.5 h-3.5 text-[#A3C1DA]" />
            GDPR-kompatibel och följer svensk lagstiftning
          </p>
        </div>
      </div>
    </div>
  );
}